// extracted by mini-css-extract-plugin
module.exports = {"image-card-list":"image-card-list___2yd48"};